import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=2106cad3&scoped=true"
import script from "./callback.vue?vue&type=script&lang=js"
export * from "./callback.vue?vue&type=script&lang=js"
import style0 from "./callback.vue?vue&type=style&index=0&id=2106cad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106cad3",
  null
  
)

export default component.exports